import { styles } from '../../../../../style';

const lensReplacementButton = { ...styles.button, margin: '0 0 15px' };

export default lensReplacementButton;
